module.exports = __webpack_public_path__ + "assets/img/Mac版.a0068636.png";